import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.JobMatching;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "JobMatching.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "JobMatching.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "JobMatching.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/JobMatchingGame/scenes/IntroductionScene.ts